import {Stack} from '@customink/pigment-react';
import PropTypes from 'prop-types';
import React from 'react';

export default function ProductCardDetailsContainer({
  children,
  isMobile,
  ...props
}) {
  return (
    <Stack
      gap="0.5rem"
      width={isMobile ? '60%' : '100%'}
      flex={1}
      data-testid="product-details-container"
      {...props}>
      {children}
    </Stack>
  );
}

ProductCardDetailsContainer.propTypes = {
  children: PropTypes.node.isRequired,
  isMobile: PropTypes.bool.isRequired,
  props: PropTypes.object
};
